import { useState, useEffect } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import { useWindowWidth } from "@wojtekmaj/react-hooks";
import { BrowserRouter as Router, useNavigate, Link } from "react-router-dom";

function Patients(props) {
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const width = useWindowWidth();
  const [length, setLength] = useState(40);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 900px)" });
  const updatePatient = (patient) => {
    props.updateSelectedPatient(patient);
    if (
      props.cardioRResults?.find((p) => p.custid == patient.custid.toString()) // if has cardioR events
    ) {
      navigate("/cardioR");
    } else {
      navigate("/activities");
    }
  };
  const toShow = props.patients?.filter(
    (pat) =>
      (pat.firstname + " " + pat.lastname).includes(search) ||
      pat.custid?.toString().includes(search)
  );
  const fillTable = toShow?.slice(0, length)?.map((pat) => (
    <tr key={pat.custid}>
      <td data-label="שם מלא:">
        <strong
          style={{ cursor: "pointer", color: "navy" }}
          onClick={() => updatePatient(pat)}
        >
          {">"} {pat.firstname + " " + pat.lastname}
        </strong>
      </td>
      <td data-label="תעודת זהות:">{pat.custid}</td>
      <td data-label="גיל:">
        {pat.sex == 1 ? "בן " : "בת "}
        {pat.birthdate && moment().diff(pat.birthdate, "years")}
      </td>
    </tr>
  ));
  return (
    <div>
      <h2>דף לקוחות</h2>
      <br />
      חיפוש חופשי:{" "}
      <input
        placeholder="שם או תעודת זהות"
        className="filterSelect"
        value={search}
        onChange={(t) => setSearch(t.target.value)}
      />
      <br />
      <br />
      <table>
        <thead>
          <tr>
            <th>שם מלא</th>
            <th>תעודת זהות</th>
            <th>גיל</th>
          </tr>
        </thead>
        <tbody>{fillTable}</tbody>
      </table>
      {toShow.length > length && (
        <div className="downloadFile" onClick={() => setLength(length + 10)}>
          הצג עוד
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    patients: state.patients,
    cardioRResults: state.cardioRResults,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateSelectedPatient: (pat) => {
      dispatch({
        type: "UPDATE_SELECTED_PATIENT",
        payload: pat,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Patients);
